<div class="control-list-container">
  <div class="option-container">
    <div class="filter-container">
      <app-filter
        [uniqueServices]="uniqueServices"
        [selectedServices]="selectedServices"
        [selectedStatuses]="selectedStatuses"
        (filterChanged)="applyFilter()"
        (searchTextChanged)="onSearchTextChanged($event)"
        (selectedServicesChanged)="onSelectedServicesChanged($event)"
        (selectedStatusesChanged)="onSelectedStatusesChanged($event)"
      ></app-filter>
    </div>
    <div class="paginator-container">
      <mat-paginator
        [pageSize]="15"
        [pageSizeOptions]="[15, 30, 60]"
        showFirstLastButtons
        aria-label="ページ選択">
      </mat-paginator>
    </div>
  </div>
  <!-- <button mat-raised-button (click)="submiterror()">テスト用エラー</button> -->

  <div class="table-container">
    <table
      mat-table
      [dataSource]="filteredDataSource"
      class="mat-elevation-z8"
      multiTemplateDataRows
    >
      <!-- Status Button Column -->
      <ng-container matColumnDef="StatusButton">
        <th mat-header-cell *matHeaderCellDef>申請</th>
        <td mat-cell *matCellDef="let element">
          <button
            class="submit-button"
            *ngIf="element.Status === 0 || element.Status === 3"
            (click)="submitForReview(element.AccountID, element.ControlID, 1)"
          >
            申請する
          </button>
          <span
            *ngIf="
              element.Status === 1 || element.Status === 2 || element.Status === 4
            "
          ></span>
        </td>
      </ng-container>
      <!-- AccountID Column -->
      <ng-container matColumnDef="AccountID">
        <th mat-header-cell *matHeaderCellDef>アカウントID</th>
        <td mat-cell *matCellDef="let element">{{ element.AccountID }}</td>
      </ng-container>

      <!-- ControlID Column -->
      <ng-container matColumnDef="ControlID">
        <th mat-header-cell *matHeaderCellDef>コントロールID</th>
        <td mat-cell *matCellDef="let element">{{ element.ControlID }}</td>
      </ng-container>

      <!-- Service Column -->
      <ng-container matColumnDef="service">
        <th mat-header-cell *matHeaderCellDef>サービス</th>
        <td mat-cell *matCellDef="let element">{{ element.service }}</td>
      </ng-container>

      <!-- Score Column -->
      <ng-container matColumnDef="ControlUnitBaseScore">
        <th mat-header-cell *matHeaderCellDef>スコア</th>
        <td mat-cell *matCellDef="let element">
          {{ element.ControlUnitBaseScore }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef class="status-header">
          ステータス
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            class="status-{{ element.Status }}"
            [ngClass]="{ 'gray-out': element.Status === 4 }"
          >
            {{ ControlStatusJP[element.Status] }}
          </span>
        </td>
      </ng-container>

      <!-- Application Time Stamp Column -->
      <ng-container matColumnDef="ApplicationTimestamp">
        <th mat-header-cell *matHeaderCellDef>申請日時</th>
        <td mat-cell *matCellDef="let element">
          {{ element.ApplicationTimestamp }}
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="ControlDescription">
        <th mat-header-cell *matHeaderCellDef>説明</th>
        <td mat-cell *matCellDef="let element">
          {{ element.ControlDescription }}
        </td>
      </ng-container>

      <!-- ApplicationCount Column -->
      <ng-container matColumnDef="ApplicationCount">
        <th mat-header-cell *matHeaderCellDef>申請回数</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.ApplicationCount === 0"></span>
          <span *ngIf="element.ApplicationCount > 0">
            {{ element.ApplicationCount }}回
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'gray-out': row.Status === 4 }"
      ></tr>
    </table>
  </div>
</div>
